import { Grid, Card, CardHeader, CardContent, Box, Button } from '@mui/material';
import { Form, useNotify, useRedirect, useTranslate } from 'react-admin';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import CustomLoginPasswordInput from '@/components/login/CustomLoginPasswordInput';
import MaasloopIcon from '@/assets/icons/maasloop.svg?react';
import RevloopIcon from '@/assets/icons/revloop.svg?react';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import LanguageSwitcher from '@/components/global/menu/LanguageSwitcher.jsx';

const StyledCard = styled(Card)(() => ({
    width: 400,
    borderRadius: '32px',
    padding: '48px 40px 16px',
    boxShadow: Palette.boxShadow.elevation3,
}));

const StyledCardHeader = styled(CardHeader)(() => ({
    padding: '0px',
    marginBottom: '14px',
    '& .MuiTypography-root': {
        fontSize: '18px',
    },
}));

const StyledCardContent = styled(CardContent)(() => ({
    padding: 0,
    '& .MuiGrid-root.MuiGrid-item': {
        width: '100%',
    },
    '& .reset-password-button': {
        padding: '14px 16px',
        marginTop: '20px',
    },
}));

const apiUrl = import.meta.env.VITE_API_URL;
const ResetPasswordPage = () => {
    const { token } = useParams();
    const redirect = useRedirect();
    const translate = useTranslate();
    const regex = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$');
    if (!regex.test(token)) {
        redirect('/login');
    }
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    const handleResetPassword = async ({ password }) => {
        setLoading(true);
        const request = new Request(`${apiUrl}/user/reset-password/${token}`, {
            method: 'POST',
            body: JSON.stringify({ password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        const response = await fetch(request);
        setLoading(false);

        if (false === response.ok) {
            const responseBody = await response.json();
            notify(responseBody.errors[0].message, { type: 'error' });
            return;
        }
        redirect('/login');
    };

    return (
        <>
            <Box sx={{ position: 'fixed', top: 32, right: 32 }}>
                <LanguageSwitcher />
            </Box>
            <Box height={'98vh'} display='flex' alignItems='center' justifyContent='center' gap={4} p={2}>
                <StyledCard>
                    <Box sx={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
                        <RevloopIcon />
                        <MaasloopIcon />
                    </Box>
                    <StyledCardHeader title={translate('auth.enterPasswordTitle')} />
                    <StyledCardContent>
                        <Form onSubmit={handleResetPassword}>
                            <Grid container>
                                <Grid item sm={12} rowSpacing={5}>
                                    <CustomLoginPasswordInput source='password' label={<span>{translate('auth.password')}</span>} isRequired={true} fullWidth />
                                </Grid>
                                <Grid item sm={12}>
                                    <Button
                                        className='reset-password-button'
                                        color='primary'
                                        size='small'
                                        type='submit'
                                        variant='contained'
                                        fullWidth
                                        disabled={loading}
                                    >
                                        {translate('auth.savePassword')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    </StyledCardContent>
                </StyledCard>
            </Box>
        </>
    );
};

export default ResetPasswordPage;
